const $inject = [];

const lbCountrySelectCtrl = function () {
  let vm = this;

  const DEFAULT_PLACEHOLDER = 'Select a country';

  vm.required = vm.required || false;
  vm.placeholder = vm.placeholder || DEFAULT_PLACEHOLDER;
  vm.countries = require('./countries.js');
  vm.showLoader = false;
};

lbCountrySelectCtrl.$inject = $inject;

export default lbCountrySelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbCountrySelect/lbCountrySelectCtrl.js